import { Texts } from '../labels/language.texts';
import { Language } from '../labels/language.labels';

export type Action = {
  type: string
}

export const InitialState: Language = {
  code: Texts.default.code,
  labels: Texts.default.labels
}

export const ReducerLanguage = (state: Language = InitialState, action : Action): Language => {
  switch(action.type) {
    case 'english':
      return { 
        code: Texts.lang.english.code,
        labels: Texts.lang.english.labels
      }
    case 'spanish':
      return { 
        code: Texts.lang.spanish.code,
        labels: Texts.lang.spanish.labels
      }
    case 'french':
      return { 
        code: Texts.lang.french.code,
        labels: Texts.lang.french.labels
      }
    case 'italian':
      return { 
        code: Texts.lang.italian.code,
        labels: Texts.lang.italian.labels
      }
    case 'german':
      return { 
        code: Texts.lang.german.code,
        labels: Texts.lang.german.labels
      }
    default:
      return state
  }
}
